import { Button, HeaderSection, Icon, IconType } from '@lmc/ui-kit'
import { ProTag } from 'components/ProTag'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  handleToggleModal: () => void
  handleView: () => void
  testId?: string
}

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export function CarerSkillsHeaderSection({
  handleView,
  handleToggleModal,
  testId
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <HeaderSection
      backLink
      onClick={handleView}
      title={
        <TitleContainer data-testid={testId ? `${testId}-title` : undefined}>
          {t(`skillsAndNeeds.skillsAndTrainings`)}
          <ProTag />
        </TitleContainer>
      }
      iconColor="#EFEEFF"
      iconContent={
        <Icon
          customIcon={IconType.LogoPurple}
          style={{ width: 26, height: 26 }}
        />
      }
      rightChildren={
        <Button
          icon={<Icon name="PlusOutlined" />}
          variant="primary"
          onClick={handleToggleModal}
          data-testid={testId ? `${testId}-add-skill-button` : undefined}
        >
          {t(`skillsAndNeeds.assignNewSkillButton`)}
        </Button>
      }
      testId={testId}
    />
  )
}

export default CarerSkillsHeaderSection
